import React from "react"
import { Link, graphql, useStaticQuery, navigate } from "gatsby"
import {
  EListingCardLayouts,
  ListingCard,
} from "@organic-return/foundation-react/src/components/Listing/ListingCard"
import { EListingVitalsLayout } from "@organic-return/foundation-react/src/components/Listing/ListingVitals"
import { Search } from "@organic-return/foundation-react/src/components/Search/Search"
import { useSiteContext } from "../common/SiteContext"

const RentalIncludeMlsSearch = ({ module, page }) => {
  const data = useStaticQuery(graphql`
    query RentalIncludeSearchQuery {
      allRental(sort: {order: DESC, fields: price}) {
        nodes {
          baths
          bathsHalf
          address {
            city
            state
            text
            street1
            street2
            postal
          }
          features
          beds
          sleeps
          type
          path
          price
          priceLow
          priceHigh
          priceSuffix
          bookings {
            endDate
            startDate
          }
          rates {
            price
            startDate
            endDate
            type
          }
          defaultImage {
            dimensions
            url
            caption
          }
          location {
            lat
            lng
          }
          seasonality
        }
      }
      allListing(
        filter: {type: {eq: "Residential Lease"}}
        sort: {fields: price, order: DESC}
      ) {
        nodes {
          baths
          address {
            city
            state
            text
            street1
            street2
            postal
          }
          features
          beds
          sleeps
          type
          path
          price
          defaultImage {
            dimensions
            url
            caption
          }
          location {
            lat
            lng
          }
        }
      }
      allAgilityRentalIncludeMlsSearch {
        nodes {
          contentID
          filter {
            customFields {
              query
            }
          }
        }
      }
    }
  `)
  const siteContext = useSiteContext()


  let initialFilter = data.allAgilityRentalIncludeMlsSearch.nodes.find((node: any) => {
    return node.contentID == module.contentID
  }).filter[0]?.customFields.query

  if (initialFilter) {
    initialFilter = initialFilter.replace(/\+/g, '%20')
    initialFilter = decodeURIComponent(initialFilter)
  }

  if (initialFilter?.includes("\"season\":\"Winter Rental\"")) {
    data.allRental.nodes.forEach((rental) => {
      var winterRates = rental.rates && rental.rates.filter(rate => rate.type?.toUpperCase() == "WINTER")
      if (winterRates[0]) {
        rental.price = winterRates[0].price;
        rental.priceSuffix = '/MTH';
      }
    })
  }

  if (initialFilter?.includes("\"season\":\"Year Round\"")) {
    data.allRental.nodes.forEach((rental) => {
      var yearlyRates = rental.rates && rental.rates.filter(rate => rate.type?.toUpperCase() == "YEARLY")
      if (yearlyRates[0]) {
        rental.price = yearlyRates[0].price;
        rental.priceSuffix = '/MTH';
      }
    })
  }
  let rentals: any[]

  const withPrice = data.allRental.nodes?.filter(rental => rental.price != null) ?? []
  const withoutPrice = data.allRental.nodes?.filter(rental => rental.price == null) ?? []
  rentals = withPrice.concat(withoutPrice);
  rentals = rentals.concat(data.allListing.nodes);

  // Small card size option (default)
  let cardClass = "w-[480px]"
  let cardImageWidth = 480
  // Large card size option
  if (module.customFields?.cardSize == "large") {
    cardClass = "w-[640px]"
    cardImageWidth = 640
  }

  // Configurable results per page defaults to 20
  let pageSize = module.customFields?.pageSize || 20
  return (
    <Search
      index={rentals}
      initialFilter={initialFilter}
      defaultSort={siteContext?.rentalSearchProps?.defaultSort}
      pageSize={pageSize}
      pageSizeOpts={[pageSize * 1, pageSize * 2, pageSize * 3, pageSize * 4]}
      pagerTop={true}
      pagerBottom={true}
      showCount={true}
      useMap={true}
      mapClick={item => navigate(item.path)}
      renderItem={(item, index) => {
        return (
          <ListingCard
            listing={item}
            layout={EListingCardLayouts.vertical}
            className={`${cardClass} max-w-full`}
            maxWidthImage={cardImageWidth}
            linkImage={true}
            key={index}
            linkFunc={props => {
              return (
                <Link
                  to={props.href}
                  className={`text-inherit ${props.className}`}
                  key={props.key}
                  title={props.title}
                >
                  {props.children}
                </Link>
              )
            }}
            {...siteContext.globalListingCardProps}
            vitalsLayout={
              module.customFields?.cardLayout ||
              EListingVitalsLayout.column1Border0
            }
          />
        )
      }}
      preRenderItem={(item, index) => {
        return (
          <a key={index} href={item.path}></a>
        )
      }}
      {...siteContext.rentalSearchProps}
    />
  )
}

export default RentalIncludeMlsSearch
